// extracted by mini-css-extract-plugin
export default {"headerBar":"headerBar_ng8iK","website-title":"website-title_o_PxI","layout":"layout_FzESY"};